import React from 'react';

import { WithdrawWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const WithdrawRoute: React.FC = () => <FirstRoute component={WithdrawWizard} noCache />;

export default WithdrawRoute;
